import React from 'react';
import { Heart, Instagram, Facebook, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo.jpg" 
                alt="Taste T Pistachio Logo" 
                className="h-12 w-12 rounded-full object-cover"
              />
              <div>
                <h3 className="text-lg font-bold text-cream">TASTE T PISTACHIO</h3>
                <p className="text-sm text-cream-dark">Homemade Delights</p>
              </div>
            </div>
            <p className="text-cream-dark text-sm">
              Handcrafted pistachio treats made with love in Clermont, FL. 
              All natural, organic, and absolutely delicious.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-cream font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => {
                  const el = document.getElementById('about');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }} className="footer-link">About Us</button>
              </li>
              <li>
                <button onClick={() => {
                  const el = document.getElementById('products');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }} className="footer-link">Products</button>
              </li>
              <li>
                <button onClick={() => {
                  const el = document.getElementById('testimonials');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }} className="footer-link">Testimonials</button>
              </li>
              <li>
                <button onClick={() => {
                  const el = document.getElementById('contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }} className="footer-link">Contact</button>
              </li>
            </ul>
          </div>

          {/* Connect Section */}
          <div>
            <h4 className="text-cream font-semibold mb-4">Connect With Us</h4>
            <div className="flex gap-3 mb-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Instagram size={20} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Facebook size={20} />
              </a>
              <a href="mailto:TasteTPistachio@gmail.com" className="social-icon">
                <Mail size={20} />
              </a>
            </div>
            <p className="text-cream-dark text-sm">
              <strong className="text-cream">Location:</strong><br />
              Clermont, Florida
            </p>
            <p className="text-cream-dark text-sm mt-2">
              <strong className="text-cream">Email:</strong><br />
              TasteTPistachio@gmail.com
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cream border-opacity-20 pt-6 text-center">
          <p className="text-cream-dark text-sm">
            © {currentYear} Taste T Pistachio. All rights reserved. Made with <Heart className="inline text-gold fill-gold" size={14} /> in Clermont, FL
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
